import getTimeDiff from "./getTimeDiff";
const timeToDate = (date, hoursText = "hours", minutesText = "minutes", daysSingularText = "day", daysPluralText = "days", weeksSingularText = "week", weeksPluralText = "weeks") => {
    let diff = getTimeDiff(date) / 1000;
    const days = Math.floor(diff / 86400);
    diff -= days * 86400;
    const hours = Math.floor(diff / 3600) % 24;
    diff -= hours * 3600;
    const minutes = Math.floor(diff / 60) % 60;
    const weeks = Math.floor(days / 7);
    if (weeks > 0) {
        return `${weeks} ${weeks === 1 ? weeksSingularText : weeksPluralText}`;
    }
    if (days > 0) {
        return `${days} ${days === 1 ? daysSingularText : daysPluralText}`;
    }
    return `${hours} ${hoursText} ${minutes} ${minutesText}`;
};
export default timeToDate;
//# sourceMappingURL=timeToDate.js.map